import React, { FormEvent, useEffect, useState } from 'react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from '@mui/material';

interface Props {
	open: boolean;
	entryLabel: string;
	dateLabel: string;
	onClose: () => void;
	onConfirm: () => void;
}

function ConfirmUnassignDateDialog({ open, entryLabel, dateLabel, onClose, onConfirm }: Props) {
	const [cachedContent, setCachedContent] = useState({ entryLabel, dateLabel });

	// cache content to prevent it from disappearing during dialog fade out
	useEffect(() => {
		if (open) {
			setCachedContent({ entryLabel, dateLabel });
		}
	}, [open, entryLabel, dateLabel]);

	const onSubmit = (e: FormEvent) => {
		e.preventDefault();
		onConfirm();
	};

	return (
		<Dialog open={open} onClose={onClose} sx={{ '& .MuiPaper-root': { minWidth: 320 } }}>
			<DialogTitle>Remove from timeline?</DialogTitle>
			<form onSubmit={onSubmit} autoComplete="off">
				<DialogContent>
					{cachedContent.entryLabel && (
						<DialogContentText sx={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', mb: 1 }}>
							&quot;{cachedContent.entryLabel}&quot;
						</DialogContentText>
					)}
					<DialogContentText>
						Its <strong>{cachedContent.dateLabel.toLowerCase()}</strong> will be cleared. The entry itself is kept.
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={onClose}>Cancel</Button>
					<Button type="submit" variant="contained" autoFocus>
						Remove
					</Button>
				</DialogActions>
			</form>
		</Dialog>
	);
}

export default ConfirmUnassignDateDialog;
